// 백엔드가 설정과 매칭한 접근로 CCTV인지 확인합니다.
export const isAccessCctv = (row) => {
    return row?.accessYn === 'Y'
        || row?.accessYn === true
        || row?.accessYn === 1
        || row?.accessYn === '1';
};
